import { render, staticRenderFns } from "./projectList.vue?vue&type=template&id=a28203b0&scoped=true&"
import script from "./projectList.vue?vue&type=script&lang=js&"
export * from "./projectList.vue?vue&type=script&lang=js&"
import style0 from "../pc.css?vue&type=style&index=0&id=a28203b0&scoped=true&lang=css&"
import style1 from "../phone.css?vue&type=style&index=1&id=a28203b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28203b0",
  null
  
)

export default component.exports